export default "__VITE_ASSET__5cdf6620__"